export const black = '#333333'
export const gray = '#9C9C9C'
export const hover = '#EFEFEF'
export const white = '#FFFFFF'
export const placeholder = '#888888'

export const primary = '#FF4D89'
export const primaryHovered = '#E3457A'

export const secondary = '#523C6C'
export const secondaryHovered = '#3B2753'

export const link = primary
export const linkHovered = primaryHovered

export const inputBackground = '#f8f8f8'
export const inputBackgroundActive = '#e8e8e8'
export const inputBackgroundError = '#FFF9F9'

export const borderColor = '#d9d9d9'
export const borderError = '#F8C3C6'

export const backgroundColor = secondary

export const filter = 'rgba(0, 0, 0, 0.3)'

export const highlight = '#99CCFF'

export const error = '#D0021B'



// WEBPACK FOOTER //
// ./src/styles/colors.js